import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/10 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
          {/* Left - Address */}
          <div className="text-white/60">
            <p>kennington</p>
            <p>London — SE11</p>
            <p>United Kingdom</p>
          </div>

          {/* Center - Copyright */}
          <div className="flex items-center justify-center text-white/60">
            <p>© Neufora 2025</p>
          </div>

          {/* Right - Contact */}
          <div className="flex items-center md:justify-end justify-center">
            <a
              href="mailto:contact.neufora@gmail.com"
              className="text-white/60 hover:text-white transition-colors underline decoration-white/30 hover:decoration-white"
            >
              contact@neufora.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;